// extracted by mini-css-extract-plugin
export default {"table":"SavedSearchResults_table__NiBCW","tableWithFilters":"SavedSearchResults_tableWithFilters__2rRyL","status":"SavedSearchResults_status__tFxKN"};